import { useEffect, useState } from 'react';
import { serviceService } from '../services/serviceService';
import type { ServiceAddon } from '../types/service.types';

export function useServiceAddons(serviceId: string | undefined) {
  const [data, setData] = useState<ServiceAddon[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!serviceId) {
      setIsLoading(false);
      return;
    }
    let cancelled = false;
    setIsLoading(true);
    setError(null);

    serviceService
      .listAddons(serviceId)
      .then((rows) => {
        if (!cancelled) setData(rows);
      })
      .catch((err: unknown) => {
        if (!cancelled) setError(err instanceof Error ? err : new Error(String(err)));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [serviceId]);

  return { data, isLoading, error };
}
